var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('aside', {
    ref: "listWrap",
    staticClass: "aside"
  }, [_c('section', {
    staticClass: "biggest-fans"
  }, [_c('h2', {
    staticClass: "bigfans-title"
  }, [_vm._v(_vm._s(_vm.$t("biggestFans")))]), _vm._v(" "), _c('div', {
    staticClass: "bigfans-box"
  }, [_vm.biggestFansList.length > 0 ? _c('ul', {
    style: {
      height: "".concat(_vm.listHeight, "px")
    }
  }, _vm._l(_vm.biggestFansList, function (biggestFans, index) {
    return _c('li', {
      key: index,
      staticClass: "bigfans-item"
    }, [_c('a', {
      attrs: {
        "href": _vm.getBigFansPersonalLink(biggestFans.uid),
        "target": _vm.target
      },
      on: {
        "click": function click($event) {
          return _vm.directToBigFansPersonalLink(biggestFans.uid, _vm.event);
        }
      }
    }, [index < 3 ? _c('span', {
      class: _vm.getMedalLevel(index)
    }) : _c('span', {
      staticClass: "medal"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), biggestFans.face ? _c('span', {
      staticClass: "headimage",
      style: {
        background: 'url(' + biggestFans.face + ') no-repeat scroll center center / contain'
      }
    }) : _c('span', {
      staticClass: "headimage"
    }), _vm._v(" "), _c('span', {
      staticClass: "username",
      attrs: {
        "title": biggestFans.uname
      }
    }, [_vm._v(_vm._s(biggestFans.uname))]), _vm._v(" "), _c('span', {
      staticClass: "diamond"
    }), _vm._v(" "), _vm.userInfo.country === 'CN' || _vm.userInfo.country === 'TW' || _vm.userInfo.country === 'HK' ? _c('span', {
      staticClass: "diamond-num",
      attrs: {
        "title": biggestFans.cnt
      }
    }, [_vm._v(_vm._s(Number(biggestFans.cnt) > 10000 ? biggestFans.cnt.substring(0, biggestFans.cnt.length - 4) + 'w' : biggestFans.cnt))]) : _c('span', {
      staticClass: "diamond-num",
      attrs: {
        "title": biggestFans.cnt
      }
    }, [_vm._v(_vm._s(Number(biggestFans.cnt) > 1000000 ? Math.ceil(biggestFans.cnt * 10 / 1000000) / 10 + 'm' : Number(biggestFans.cnt) > 1000 ? Math.ceil(biggestFans.cnt * 10 / 1000) / 10 + 'k' : biggestFans.cnt))])])]);
  }), 0) : _c('div', {
    staticClass: "no_data"
  }, [_vm._v(_vm._s(_vm.$t("noData")))])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };